"use client"

import { SignUp } from "@clerk/nextjs"

export default function SignUpPage() {
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-md mx-auto my-16">
        <SignUp fallback={
          <div className="w-full h-96 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8E82FF]"></div>
        </div>
        } />
    </div>
  )
}
